import { DateTime, Duration } from 'luxon'

export function getNextOccurrence(hourOfDay: number, nowSeconds?: number) {
  const now = nowSeconds ? DateTime.fromSeconds(nowSeconds, { zone: 'utc' }) : DateTime.utc()
  if (hourOfDay === 0) return now.plus({ day: 1 }).startOf('day')
  return now.plus({ hour: 24 - hourOfDay }).startOf('day').plus({ hour: hourOfDay })
}

export function thisOccurrence(hourOfDay: number, nowSeconds: number) {
  return getNextOccurrence(hourOfDay, nowSeconds).minus({ second: 1 })
}

export function getNextOccurrenceDiffFromNow(hourOfDay: number, nowSeconds: number) {
  return getNextOccurrence(hourOfDay).minus({ second: 1 }).diff(DateTime.fromSeconds(nowSeconds, { zone: 'UTC' }))
}

export function formatMillisecondDuration(milliseconds: number): string {
  const dur = Duration.fromMillis(Math.max(0, milliseconds)).shiftTo('minutes', 'seconds', 'milliseconds')

  return dur.toFormat('mm\':\'ss\'.\'SSS')
}

export function formatDuration(duration: number, format: string = 'hh:mm:ss', showDays: boolean = false, showShortFormat: boolean = false) {
  // Guard against NaN, undefined, null, or invalid values
  if (!Number.isFinite(duration)) {
    return showDays ? '0 days' : '00:00:00'
  }

  if (showDays) {
    const days = Math.floor(duration / 86400)
    return `${days} day${days !== 1 ? 's' : ''}`
  }

  if (showShortFormat) {
    const dur = Duration.fromObject({ seconds: Math.max(0, duration) })
    let formattedTime = ''

    if (dur.as('hours') >= 1) {
      formattedTime = dur.toFormat('hh\'h\' mm\'m\' ss\'s\'')
    } else if (dur.as('minutes') >= 1) {
      formattedTime = dur.toFormat('mm\'m\' ss\'s\'')
    } else {
      formattedTime = dur.toFormat('ss\'s\'')
    }
    return formattedTime
  }

  return Duration.fromObject({ seconds: Math.max(0, duration) }).toFormat(format)
}

export function isTodayDate(dateTime: DateTime) {
  return dateTime.startOf('day').toSeconds() === DateTime.now().startOf('day').toSeconds()
}

export function currentTimestamp(): number {
  return DateTime.utc().toUnixInteger()
}

export function getDayStartTimestamp(date: string, format = 'yyyy-MM-dd'): number {
  return DateTime.fromFormat(date, format).startOf('day').toUnixInteger()
}